


































import KlaviyoMixin from 'library/mixins/klaviyo-mixin'
import { IDENTIFY_EMAIL_EVENT } from 'library/constants'

export default

	mixins: [ KlaviyoMixin ]

	props:
		footer: Boolean
		formId: String

	data: ->
		email: ''
		errorMessage: ''
		successMessage: ''

	computed:
		isInverted: -> if @footer then return true

		uniqueFormId: -> "klaviyo_form_#{@formId}"

	methods:
		onKlaviyoLoad: ->
			@$refs.emailForm.addEventListener('submit', @onSubmit)
			KlaviyoSubscribe.attachToForms("##{@uniqueFormId}",
				hide_form_on_success: true,
				extra_properties:
					$source: '$embed',
					$method_type: "Klaviyo Form",
					$method_id: 'embed',
					$consent_version: 'Embed default text');

		onSubmit: (event) ->
			try
				KlaviyoSubscribe.isFormValid( $("##{@uniqueFormId}") )
				@$gtmEcomm.pushEvent IDENTIFY_EMAIL_EVENT, { @email }
				@successMessage = "Successful Signup"
			catch error
				@errorMessage = error
				@successMessage = ''

	watch:
		email: -> if @errorMessage then @errorMessage = ""

